import { useState, useEffect } from "react";
import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { globalError } from "src/utils/globalError";

export default function ErrorDialog() {
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState({ title: "", message: "" });

  useEffect(() => {
    globalError.subscribe(({ title, message }) => {
      setPayload({ title, message });
      setOpen(true);
    });
  }, []);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>{payload.title}</DialogTitle>
      <DialogContent>
        <p>{payload.message ?? "Something went wrong."}</p>
        <div className="mt-4 text-right">
          <Button onClick={() => setOpen(false)} variant="contained">
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
